import { BehaviorSubject } from 'rxjs';
import { useObservableValue } from 'src/hooks/useObservableValue';
import type { LocatesClient } from 'src/lib/locates/interface';
import { LocatesClientLegacyImpl } from 'src/lib/locates/modern';

const client$ = new LocatesClientLegacyImpl();
const clientAsBehaviorSubject = new BehaviorSubject<LocatesClient>(client$);

/**
 * Legacy locates client accessor for use in sagas only.
 *
 * This provides access to the legacy RESTful HTTP client used by the old LocatesWidget.
 * For components, use useLocatesClient() hook instead.
 *
 * For new features, prefer the modern React Query approach used in LAB Admin (see queries/labOrders.ts).
 */
export function getLocatesClient(): LocatesClient {
    return client$;
}

/**
 * Legacy React hook for accessing the locates client.
 *
 * This provides access to the legacy RESTful HTTP client used by the old LocatesWidget.
 * TODOLOCATES: this is used in 1 place for cancel all; just turn cancel all into a saga and delete this
 *
 * For new features, prefer the modern React Query approach used in LAB Admin (see queries/labOrders.ts).
 *
 * @returns Legacy locates client appropriate for the current user and environment
 */
export function useLocatesClient(): LocatesClient {
    return useObservableValue(clientAsBehaviorSubject, clientAsBehaviorSubject.value);
}
